import React from 'react'

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import colors from '../../theme/foundations/colors'

import FooterBottom from '../footer/footer-bottom.jsx'

/**
 * Renders a minimal footer component for the application.
 *
 * This component utilizes a `Box` element to structure the footer and applies
 * a background color from the `colors` palette. It includes the `FooterBottom`
 * component with a minimal configuration.
 *
 * @returns {JSX.Element} A JSX element representing the minimal footer.
 */
const MinimalFooter = () => {
    return (
        <Box as="footer" id="footer-main">
            <Box bg={colors.lightBeige}>
                <FooterBottom isMinimal={true} />
            </Box>
        </Box>
    )
}

export default MinimalFooter
